import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

export const isDatePickerValidDate = (date: MaterialUiPickersDate) => {
  if (!date) {
    return false;
  }
  return date instanceof Date && !isNaN(date as unknown as number);
};
